import { routeConfig } from '@/components/modules/rule-components/routeConfig'
import type { FormContextType } from '@/routes/rule/facebook.lazy'
import { createFileRoute } from '@tanstack/react-router'
import { createContext } from 'react'

export const Route = createFileRoute('/rule/facebook')(routeConfig())
export const FormContext = createContext<FormContextType>({} as FormContextType) // <--- 留意这个类型
